import { faqItems } from '@/mocks/home';

function FAQItem({ item, isOpen, onToggle }: {
  item: typeof faqItems[0];
  isOpen: boolean;
  onToggle: () => void;
}) {
  return (
    <div className="border border-background-200/70 rounded-xl overflow-hidden">
      <button
        className="w-full flex items-center justify-between p-5 text-left bg-background-50 hover:bg-background-100 transition-colors"
        onClick={onToggle}
      >
        <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
          {item.question}
        </span>
        <div className={`w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${
          isOpen ? 'bg-primary-500 text-white rotate-45' : 'bg-background-200 text-foreground-500'
        }`}>
          <i className="ri-add-line text-sm"></i>
        </div>
      </button>
      <div
        className={`transition-all duration-300 overflow-hidden ${
          isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-5 pb-5 pt-1">
          <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
        </div>
      </div>
    </div>
  );
}

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full uppercase tracking-wider mb-4">
            常见问题
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            您可能关心的问题
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm">
            以下是关于开元体育平台的常见问题解答，如果您还有其他疑问，欢迎随时联系我们的客服团队
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <FAQItem
              key={item.id}
              item={item}
              isOpen={openId === item.id}
              onToggle={() => setOpenId(openId === item.id ? null : item.id)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}